'use client';

import { forwardRef, type ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

type TableRootProps = ComponentProps<'div'>;

const TableRoot = forwardRef<HTMLDivElement, TableRootProps>(
	({ className, children, ...props }, ref) => {
		return (
			<div
				{...props}
				ref={ref}
				className={twMerge(
					'relative h-full min-h-full w-full flex-1 overflow-auto rounded-md bg-dm-black shadow-sm',
					className
				)}
			>
				<table className="absolute w-full table-fixed border-separate border-spacing-0 text-sm">
					{children}
				</table>
			</div>
		);
	}
);

TableRoot.displayName = 'TableRoot';

export default TableRoot;
